import { useFeedV2Store } from "@/common/store/useFeedV2Store";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { useCallback } from "react";

const AD_POSITION_FACTOR = 5;
const AD_POSITION_FACTOR_V2FEED = 9;

export const useCanShowStreamateDisptacher = () => {
  const isV2Variant = useFeedV2Store((state) => state.isV2Variant);
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;

  const canShowStreamateDisptacher = useCallback((position: number) => {
    if (isV2Variant && isMobile) {
      return (position + 1) % AD_POSITION_FACTOR_V2FEED === 0;
    }

    return position === 2 || (position - 2) % AD_POSITION_FACTOR === 0;
  }, [isV2Variant, isMobile]);

  return canShowStreamateDisptacher;
};
